import type { ReactNode } from 'react'
import { scaled } from '../lib/scale'

/** An item's emoji icon at about the size of the glyph it replaces, or `fallback` when it has none. */
export function ItemIcon({ icon, fallback, size = 16 }: { icon?: string; fallback?: ReactNode; size?: number }) {
  if (!icon) return <>{fallback}</>
  return (
    <span className="inline-flex flex-none items-center justify-center leading-none" style={{ width: scaled(size + 2), height: scaled(size + 2), fontSize: scaled(size) }} aria-hidden="true">
      {icon}
    </span>
  )
}
